module.exports = __webpack_public_path__ + "img/BINDI 1 LIME.f2ebe28.svg";